import { usePage } from '@inertiajs/react';
import type { ReactNode } from 'react';
import { I18nProvider } from '@/i18n/context';
import type { Locale } from '@/i18n/messages';

function resolveLocale(raw: unknown): Locale {
    if (raw === 'de' || raw === 'tr' || raw === 'en') {
        return raw;
    }
    if (typeof raw === 'string') {
        const lower = raw.toLowerCase();
        if (lower.startsWith('de')) {
            return 'de';
        }
        if (lower.startsWith('tr')) {
            return 'tr';
        }
    }
    return 'en';
}

export function I18nBridge({ children }: { children: ReactNode }) {
    const page = usePage<{ locale?: string }>();
    const locale = resolveLocale(page.props.locale);

    return <I18nProvider locale={locale}>{children}</I18nProvider>;
}
